import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { toast } from "sonner";
import { AuthShell } from "@/components/auth-shell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { supabase } from "@/integrations/supabase/client";
import { azError } from "@/lib/az-errors";

export const Route = createFileRoute("/sifre-yenile")({
  ssr: false,
  head: () => ({
    meta: [
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { title: "Yeni şifrə — Albazar.az" },
      { name: "description", content: "Albazar.az hesabınız üçün yeni şifrə təyin edin." },
      { property: "og:title", content: "Yeni şifrə — Albazar.az" },
      { property: "og:description", content: "Yeni şifrə təyin edin." },
    
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: ResetPassword,
});

function ResetPassword() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Şifrə ən azı 6 simvol olmalıdır");
      return;
    }
    if (password !== confirm) {
      toast.error("Şifrələr uyğun gəlmir");
      return;
    }
    setBusy(true);
    const { error } = await supabase.auth.updateUser({ password });
    setBusy(false);
    if (error) {
      toast.error(azError(error));
      return;
    }
    toast.success("Şifrəniz yeniləndi");
    navigate({ to: "/profil", replace: true });
  };

  return (
    <AuthShell
      title="Yeni şifrə təyin edin"
      subtitle="Hesabınız üçün yeni şifrə yazın"
      footer={<Link to="/giris" className="font-semibold text-primary">Girişə qayıt</Link>}
    >
      <form className="space-y-4" onSubmit={submit}>
        <div>
          <Label htmlFor="pw">Yeni şifrə</Label>
          <Input id="pw" type="password" autoComplete="new-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 h-11 rounded-2xl" placeholder="••••••••" />
        </div>
        <div>
          <Label htmlFor="pw2">Şifrəni təsdiqlə</Label>
          <Input id="pw2" type="password" autoComplete="new-password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-2 h-11 rounded-2xl" placeholder="••••••••" />
        </div>
        <Button type="submit" disabled={busy} className="h-12 w-full rounded-2xl text-base">
          {busy ? "Gözləyin..." : "Şifrəni yenilə"}
        </Button>
      </form>
    </AuthShell>
  );
}
